// Las reglas de una contraseña nueva. Sin React, sin red: solo lo que se puede decir del
// texto que hay escrito en los tres campos.
//
// POR QUE VIVE APARTE. Hay DOS pantallas que cambian la contraseña y hacen cosas distintas:
// la del primer acceso —la cuenta de aula, que nace con una clave impresa en un papel que ha
// dado la vuelta a la clase— y la de Ajustes, para cuando a uno le apetece cambiarla. Si cada
// una lleva sus condiciones escritas a mano, en poco tiempo una acepta lo que la otra rechaza
// y nadie sabe cuál manda. Aquí están una sola vez, y las dos preguntan a la misma.
//
// LO QUE ESTO NO HACE: decir si la contraseña actual es la buena. Eso solo lo sabe el
// servidor, que es quien tiene el hash. Aquí se comprueba que esté ESCRITA, no que acierte.

export const MINIMO = 6;

// Los avisos se escriben una vez para que las dos pantallas digan lo mismo con las mismas
// palabras. Un mensaje distinto en cada sitio para la misma regla parece otra regla.
export const AVISOS = {
  corta: `Al menos ${MINIMO} caracteres.`,
  distintas: "Las dos no coinciden.",
  igual: "Esa es la que ya tienes puesta.",
  falta: "Escribe la que tienes ahora.",
};

/**
 * ¿Se puede guardar ya, y qué hay que decirle a quien la está escribiendo?
 *
 * `primeraVez` es la cuenta de aula estrenando su clave: ahí no se pide la anterior, porque
 * la anterior venía en el papel y pedirla otra vez no comprueba nada.
 *
 * NO SE REGAÑA A CAMPOS VACIOS. Quien acaba de abrir el formulario no ha hecho nada mal, y
 * tres avisos en rojo antes de escribir una letra es lo que hace que la gente se vaya.
 *
 * @returns {{puede: boolean, avisos: {actual?: string, nueva?: string, repetida?: string}}}
 */
export function revisa({ actual = "", nueva = "", repetida = "", primeraVez = false } = {}) {
  const avisos = {};

  if (nueva) {
    if (!primeraVez && actual && nueva === actual) avisos.nueva = AVISOS.igual;
    else if (nueva.length < MINIMO) avisos.nueva = AVISOS.corta;
  }
  if (repetida && nueva !== repetida) avisos.repetida = AVISOS.distintas;
  // El aviso de la actual solo aparece cuando ya se ha escrito la nueva: antes de eso, el
  // campo vacío no es un error, es un campo que todavía no le ha tocado el turno.
  if (!primeraVez && nueva && !actual) avisos.actual = AVISOS.falta;

  const puede = nueva.length >= MINIMO
    && nueva === repetida
    && (primeraVez || (actual.length > 0 && actual !== nueva));

  return { puede, avisos };
}
